import OpenDetailsButton from 'Components/Generic/Buttons/OpenDetailsButton';
import { SITE_PAGES } from 'Config';
import { getUserNameFromId } from 'Data/context/Users';
import SiteDrawerData from 'Data/SiteDrawerData';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { isItemInactive, isUserAuthorized } from 'Util';
import UserDetails from '../../pages/Admin/Users/UserDetails';

import styles from './SiteDrawerContainer.module.css';

const UserNameWithDrawerButton = ({
  userId,
  label,
  includeLinkToDetails = true,
  wrapText = false,
  ...props
}) => {
  const navigate = useNavigate();
  const onClickForDetail = () => {
    SiteDrawerData.close();
    navigate(`${SITE_PAGES.MANAGE_USERS.to}/${userId}`);
  };

  let userName = getUserNameFromId(userId);
  let drawerTitle =
    includeLinkToDetails &&
    isUserAuthorized(SITE_PAGES.MANAGE_USERS.requiredAuth) ? (
      <span className={isItemInactive(userName) ? styles.inactive : ''}>
        {userName}
        <OpenDetailsButton
          tooltipText='Click to manage user'
          clickHandler={onClickForDetail}
        />
      </span>
    ) : (
      userName
    );

  let drawerContent = userId != null && (
    <UserDetails {...props} userId={userId} />
  );

  const onClick = () => {
    SiteDrawerData.open({
      content: drawerContent,
      title: drawerTitle,
    });
  };

  return (
    (label || userName) && (
      <span
        className={`${styles.no_wrap_drawer_button_text} ${
          isItemInactive(userName) ? styles.inactive : ''
        }`}
        onClick={onClick}>
        {label || userName}
      </span>
    )
  );
};

UserNameWithDrawerButton.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.object,
  includeLinkToDetails: PropTypes.bool,
  wrapText: PropTypes.bool,
};

export default UserNameWithDrawerButton;
